// Final steps section questionnaire constants
export enum FinalStepsQuestionnaireItem {
  FINAL_STEPS = 'final-steps',
  FINAL_STEPS_CURRENT_CERT_PERIOD = 'final-steps/current-cert-period',
  FINAL_STEPS_DISCHARGE_COMMUNICATION = 'final-steps/discharge-communication',
  FINAL_STEPS_RESOURCES_PROVIDED = 'final-steps/resources-provided',
  FINAL_STEPS_CAREGIVER_RESPONSE = 'final-steps/caregiver-response',
  FINAL_STEPS_DATE_PHYSICIAN_NOTIFIED = 'final-steps/date-physician-notified',
  FINAL_STEPS_DISCHARGE_NARRATIVE = 'final-steps/discharge-narrative',
  FINAL_STEPS_INTERNAL_NOTES = 'final-steps/internal-notes'
}
